export default __webpack_public_path__ + "static/media/4.7fa214a0.PNG";